import { ENVIRONMENT_SELECTOR_KEY } from '@t-soft-io/retail-shared'
import {
  COUNTRY_OPTIONS,
  CountryOverride,
  DEFAULT_COUNTRY,
  DEV_COUNTRY_OVERRIDES,
  PROD_COUNTRY_OVERRIDES,
  PROD_SELECTOR_HOST
} from './constants'

export const isProdSelectorHost = (): boolean => {
  try {
    return window.location.hostname === PROD_SELECTOR_HOST
  } catch {
    return false
  }
}

// Country -> override table for the current host. The prod selector host maps to the
// prod client ids; every other host (dev, localhost) uses the dev ids.
export const getActiveCountryOverrides = (): Record<string, CountryOverride> =>
  isProdSelectorHost() ? PROD_COUNTRY_OVERRIDES : DEV_COUNTRY_OVERRIDES

// Countries offered in the selector for the current host: only those configured for the
// active environment (e.g. the Testovia test tenant is dev-only, so it never shows on prod).
export const getCountryOptions = () =>
  COUNTRY_OPTIONS.filter((opt) => getActiveCountryOverrides()[opt.id])

const isSelectableCountry = (key: string): boolean => Boolean(getActiveCountryOverrides()[key])

export const getSelectedCountry = (): string => {
  try {
    const selected = localStorage.getItem(ENVIRONMENT_SELECTOR_KEY)
    if (selected && isSelectableCountry(selected)) {
      return selected
    }
    return DEFAULT_COUNTRY
  } catch {
    return DEFAULT_COUNTRY
  }
}

export const setSelectedCountry = (countryKey: string): boolean => {
  try {
    if (!isSelectableCountry(countryKey)) {
      return false
    }
    localStorage.setItem(ENVIRONMENT_SELECTOR_KEY, countryKey)
    return true
  } catch {
    return false
  }
}

export const getCurrentCountryOverrides = (): Partial<CountryOverride> => {
  const key = getSelectedCountry()
  return getActiveCountryOverrides()[key] ?? {}
}
